<div class="ticket-container">
  <div class="ticket-content">
    <div class="success-icon">
      <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="#4CAF50"/>
        <path d="M9 12l2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    
    <h1 class="thank-you-title">¡Compra realizada con éxito!</h1>
    <p class="success-message">Su pago ha sido procesado correctamente.</p>
    
    <div class="ticket-section">
      <h2>Su número de ticket es:</h2>
      <div class="ticket-number">{{ ticketNumber }}</div>
      <p class="ticket-instructions">Retire su pedido en el mostrador con este ticket</p>
    </div>
    
    <div class="countdown-section">
      <p>La página se refrescará automáticamente en:</p>
      <div class="countdown-timer">{{ countdown }}s</div>
    </div>
    
    <div class="instructions">
      <p>¡Gracias por su compra! Por favor, diríjase al mostrador con su ticket para recibir su pedido.</p>
    </div>
  </div>
</div>
